module.exports = __webpack_public_path__ + "static/images/cross-in-circle.8bfa465af28d16697205fd5726cd4ba8.svg";